<template>
    <v-container fluid class="pr-0 pl-0">
        <logo @cambiaAnio="getData" v-sticky="{ zIndex: 4, stickyTop: 65}" />
        <navParameters :navParams="navParams"/>
        <v-row>
            <v-col cols="12">
                <TituloPrincipal :titulo="tituloIndicador"/>
            </v-col>
        </v-row>
        <TablaEducacion @reload="getData" ref="educacion" :headers="headers" :indicadorActual="indicadorActual" :tipoActividad="casoUNo"/>
    </v-container>
</template>
<script>

import TablaEducacion from "@/components/parametros/EducacionAmbiental/EducacionAmbTablaComponent"
import TituloPrincipal from '@/components/utils/TituloPrincipalComponent'
import NavParameters from '@/components/utils/NavParameterComponent'
import Logo from '@/components/utils/CompanyComponent'
import VueSticky from 'vue-sticky'

export default {
    components: {
        TablaEducacion,
        TituloPrincipal,
        NavParameters,
        Logo
    },
    mounted(){
       setTimeout(function () {this.loadingModal(false)}.bind(this), 1000);
    },
    directives: {
        'sticky': VueSticky,
    },
    props: [
        'navParams'
    ],
    computed:{
        anioConsulta() {
            return this. $store.getters.anioConsulta;
        },
        indicadorActual() {
            return parseInt(this.$store.getters.indicadorActual);
        },
        tituloIndicador(){
            let constantes = this.$store.getters.constantes;
            switch(this.indicadorActual){
                case constantes.indicadorEnergia:
                    return "Actividades Educación Ambiental de Electricidad";
                case constantes.indicadorAgua:
                    return "Actividades Educación Ambiental de Agua";
                case constantes.indicadorCombustibles:
                    return "Actividades Educación Ambiental de Combustibles";
                case constantes.indicadorAguasResiduales:
                    return "Actividades Educación Ambiental de Aguas Residuales";
                case constantes.indicadorResiduos:
                    return "Actividades Educación Ambiental de Gestión de Residuos";
                case constantes.indicadorAdaptacion:
                    return "Actividades Educación Ambiental de Adaptación";
                case constantes.indicadorCompensacion:
                    return "Actividades Educación Ambiental de Compensación";
                case constantes.indicadorContamiAdmosf://gases refrigerantes
                    return "Actividades Educación Ambiental de Gases Refrigerantes";
            }
        },
        casoUNo() {
            let constantes = this.$store.getters.constantes;
            return constantes.TIPO_ACTIVIDAD.ACTIVIDAD_CASO_UNO
        },
    },
    data: () => ({
        headers: [
            {
                text: 'Acciones',
                value: 'action',
                align: 'center',
                class: "educTable",
            },
            {
                text: "Tipo de Actividad",
                value: "tipoActividad",
                align: "center",
                class: "educTable",
            },
            {
                text: "Descripción de la Actividad",
                value: "descripcion",
                align: "start",
                class: "educTable",
            },
            {
                text: "Cantidad de Actividades",
                value: "cantidadActividades",
                align: "center",
                class: "educTable",
            },
            {
                text: "Fecha de la Actividad",
                value: "fechaActividad",
                align: "center",
                class: "educTable",
            },
            {
                text: "Cantidad de Personas",
                value: "cantidadPersonas",
                align: "center",
                class: "educTable"
            },
            {
                text: "Temas Tratados",
                value: "temasTratados",
                align: "center",
                class: "educTable"
            },
            {
                text:"Evidencia",
                value: "evidencia",
                align: "center",
                class: "educTabla",
            }

        ],
    }),
    methods: {
        getData() {
            this.$refs.educacion.getDataPorAnio();
        },
        loadingModal(modal) {                        
            this.$store.dispatch('loadingPage', modal);
        },
    }
}
</script>